<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row class="mb-1">
        <b-col cols="12" v-if="item">
          <button type="button" v-if="ableToRevertActions && item.state === 1" class="btn btn-sm btn-warning" @click="archiveItem(item)">{{ $t('buttons.archive') }}</button>
          <b-btn size="sm" v-else-if="ableToRevertActions" variant="warning" @click="unArchiveItem(item)">{{ $t('buttons.unArchive') }}</b-btn>
          <router-link v-if="prevRoute && prevRoute.name && prevRoute.name === 'Overview'" :to="{ name: 'Overview' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToDashboard')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else-if="prevRoute && prevRoute.name === 'EXCMNoteList'" :to="{ name: 'EXCMNoteList' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToNoteList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-if="prevRoute && prevRoute.name === 'TimetableDashboard'" :to="{ name: 'TimetableDashboard' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToCRM')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else :to="{ name: 'EXCMCaseList' }" class="btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" lg="8" >
          <case-header
            :item="item"
            :visibleCaseManage="visibleCaseManage"
            :ableToRevertActions="ableToRevertActions"
            @closeCase="closeCase($event)"
            @editCase="editCase($event)"
            @openCase="openCase($event)"
            @settleCase="settleCase($event)"
          ></case-header>
          <b-tabs>
            <b-tab :title="$t('views.excmcase.show.caseDetails')" class="pt-4" active>
              <b-row>
                <b-col md="12" v-if="item">
                  <b-card v-if="ableToShowDevice && item.idDevice">
                    <case-device></case-device>
                  </b-card>
                  <case-ticket
                    :item="item"
                    :caseParams="caseParams"
                  >
                  </case-ticket>
                  <b-card v-if="caseParams.hasTicket">
                    <b-col>
                      <CaseRelatedCases :path="item['@id']" :fetch-data="() => this.retrieve(decodeURIComponent(this.$route.params.id))"></CaseRelatedCases>
                    </b-col>
                  </b-card>
                  <b-card v-if="item">
                    <b-col>
                    <timetable-notes :id-case="item['@id'] || ''"
                                     :id-firm="contractorId"></timetable-notes>
                    </b-col>
                  </b-card>
                  <b-row v-if="ableToShowRelations">
                    <b-col lg="6" md="12">
                      <b-card>
                        <b-col>
                          <upcoming-relations
                            :id-case="idCase"
                            @setContactType="contactType = $event"
                          ></upcoming-relations>
                        </b-col>
                      </b-card>
                    </b-col>
                    <b-col lg="6" md="12">
                      <b-card>
                        <b-col>
                          <upcoming-relations
                            :id-case="idCase"
                            :contact-type="2"
                            @setContactType="contactType = $event"
                          ></upcoming-relations>
                        </b-col>
                      </b-card>
                    </b-col>
                  </b-row>
                  <b-row v-if="ableToViewDocuments && documents && documents.length > 0">
                    <b-col>
                      <b-card>
                        <div class="mb-1">
                          <i class="ml-2 fa fa-file-invoice fa-lg"></i><span class="h6 ml-2">{{ $t('views.documents.index') }}</span>
                          <hr class="mb-1 mt-1">
                        </div>
                        <div>
                          <table class="table table-sm">
                            <thead>
                            <tr>
                              <th>{{$t('views.exsbdocument.list.documentType')}}</th>
                              <th>{{$t('views.excmtask.list.table.task')}}</th>
                              <th>{{$t('views.exsbdocument.list.number')}}</th>
                              <th>{{$t('views.exsbdocument.list.dateOfIssue')}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in documents" :key="item['@id']">
                              <td>
                                {{ item['documentType'].name }}
                              </td>
                              <td v-if="item.task">
                                <router-link v-if="ableToViewTask" :to="{ name: 'EXCMTaskShow', params: { id: item.task['@id'] } }">
                                  {{ item.task.idTaskType.title }}
                                </router-link>
                                <span v-else> {{ item.task.idTaskType.title }} </span>
                              </td>
                              <td v-else></td>
                              <td>
                                <router-link v-if="true" :to="{ name: 'EXSBDocumentShow', params: { id: item['@id'] } }">
                                  {{ item.number }}
                                </router-link>
                                <span v-else> {{ item.task.idTaskType.title }} </span>
                              </td>
                              <td>
                                {{ $moment(item.dateOfIssue).format('YYYY-MM-DD') }}
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </b-card>
                    </b-col>
                  </b-row>
                  <b-row v-if="ableToViewOrderList">
                    <b-col cols="12">
                      <b-card>
                        <div class="mb-1">
                          <i class="fa fa-truck fa-lg"></i>
                          <span class="h6 ml-2">{{ $t('routes.EXSBOrderList') }}</span>
                          <button
                            v-if="ableToAddOrder"
                            type="button"
                            class="btn btn-info btn-circle btn-sm float-right mt-0"
                            v-b-tooltip.hover :title="$t('buttons.add')" @click="createOrder()">
                            <i class="fa fa-plus"></i>
                          </button>
                        </div>
                        <case-order-table
                          @extract="duplicateOrder($event, true)"
                          @duplicate="duplicateOrder($event)"
                          @complete="duplicateOrder($event, false, true)"
                          @price="duplicateOrder($event, false, false, true)"
                          @reload="getOrders()"
                          :items="orders"></case-order-table>
                      </b-card>
                    </b-col>
                  </b-row>
                  <b-card v-if="item">
                    <b-col>
                      <document-files :path="'api/e_x_c_m_cases/'" :item="item" :fetch-data="() => this.retrieve(decodeURIComponent(this.$route.params.id))"></document-files>
                    </b-col>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-col>
        <b-col lg="4" sm="12">
          <case-categorization v-if="caseParams.hasCategorization"
            :item="item"
            :visibleCaseManage="visibleCaseManage"
            @deleteCaseProblem="deleteCaseProblem($event)"
          >
          </case-categorization>
          <b-tabs>
            <b-tab :title="$t('views.excmcase.show.timeline')" v-if="caseParams.hasTimeline">
              <case-timeline
                :item="item"
                :ableToShowTask="ableToViewTask"
                :ableToUpdateCase="item.canUpdate"
                @reload="retrieve(decodeURIComponent($route.params.id))"
              ></case-timeline>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
        <!--</b-col>-->
        <div class="col-lg-12"  v-if="item">
          <add-case-problem-to-case-modal @reload="retrieve(decodeURIComponent($route.params.id))" :id-case="item['@id']"></add-case-problem-to-case-modal>
          <create-task-modal :id-case="item['@id']"></create-task-modal>
          <TaskCloseManuallyModal></TaskCloseManuallyModal>
          <PhoneCreateModal
            :id-case="item['@id']"
            :id-firm="contractorId"></PhoneCreateModal>
          <MeetingCreateModal
            :id-case="item['@id']"
            :id-firm="contractorId"></MeetingCreateModal>
          <create-order-modal :id-extracted-order="extractedOrderId" :id-duplicated-order="duplicatedOrderId" :id-firm="contractorId" :id-contractor="partnerId" :id-case="$route.params.id" :initial-item="initialOrderItem"></create-order-modal>
        </div>
    </b-col>
  </b-row>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Tag } from 'element-ui'
import TimeLine from 'src/components/UIComponents/TimeLine/TimeLine'
import TimeLineItem from 'src/components/UIComponents/TimeLine/TimeLineItem'
import Progress from 'src/components/UIComponents/Progress'
import moment from 'moment'
import AddCaseProblemToCaseModal from './modals/addCaseProblemToCaseModal'
import getId from '@/utils/getIdFromLink'
// import AddTaskToCaseModal from './components/addTaskToCaseModal'
import CreateTaskModal from '@/components/Dashboard/Views/excmtask/modals/CreateTaskModal'
import {checkPermission, getUserRoles} from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'
// import VueCookie from 'vue-cookie'
import TaskCloseManuallyModal from '../excmtask/components/TaskCloseManually/TaskCloseManuallyModal'
import TaskHistoryCollapse from '../excmtask/components/TaskHistory/TaskHistoryCollapse'
import VueCookie from 'vue-cookie'
import getIdFromLink from '../../../../utils/getIdFromLink'
import CaseHeader from './components/CaseHeader'
// import CaseNotes from './components/CaseNotes'
import CaseTimeline from './components/CaseTimeline'
import CaseCategorization from './components/CaseCategorization'
import CaseTicket from './components/CaseTicket'
import UpcomingRelations from '@/components/Dashboard/Views/common/UpcomingRelations'
import CaseDevice from '@/components/Dashboard/Views/excmcase/components/CaseDevice'
import TimetableNotes from '@/components/Dashboard/Views/common/TimetableNotes'
import MeetingCreateModal from '@/components/Dashboard/Views/excmrelation/modals/MeetingCreateModal'
import PhoneCreateModal from '@/components/Dashboard/Views/excmrelation/modals/PhoneCreateModal'
import ApiService from '@/utils/ApiService'
import DocumentFiles from '@/components/Dashboard/Views/common/DocumentFiles'
import {ENTRYPOINT} from '@/config/entrypoint'
import CaseOrderTable from '@/components/Dashboard/Views/excmcase/components/CaseOrderTable'
import addParamsToQuery from '@/utils/addParamsToQuery'
import CreateOrderModal from '@/components/Dashboard/Views/BusinessBundle/exsborder/modals/CreateModal'
import CaseRelatedCases from '@/components/Dashboard/Views/excmcase/components/CaseRelatedCases.vue'

export default {
  data () {
    return {
      initialOrderItem: {},
      duplicatedOrderId: null,
      extractedOrderId: null,
      contactType: null,
      caseParams: {},
      moment,
      ableToRevertActions: false,
      prevRoute: null
    }
  },
  components: {
    CaseRelatedCases,
    CaseOrderTable,
    DocumentFiles,
    MeetingCreateModal,
    PhoneCreateModal,
    TimetableNotes,
    CaseDevice,
    CreateTaskModal,
    AddCaseProblemToCaseModal,
    [Progress.name]: Progress,
    [Tag.name]: Tag,
    TimeLine,
    TimeLineItem,
    Loader,
    TaskCloseManuallyModal,
    TaskHistoryCollapse,
    CaseHeader,
    // CaseNotes,
    CaseTimeline,
    CaseCategorization,
    CaseTicket,
    UpcomingRelations,
    CreateOrderModal
  },
  watch: {
    '$route.params' () {
      this.retrieve(decodeURIComponent(this.$route.params.id))
      this.getOrders()
    },
    'item' () {
      this.getCaseTypeParams(this.item.caseType['@id'])
      if (this.item.tasks && this.item.tasks.length > 0) {
        let array
        array = this.item.tasks.map(task => getId(task['@id']))
        this.fetchDocuments({ task: array })
      }
    },
    'isCreateTaskModalVisible' (val) {
      if (!val && this.createdTask) {
        this.retrieve(decodeURIComponent(this.$route.params.id))
        this.resetCreatedTask()
      }
    },
    'orderCreated' (val) {
      if (val) this.getOrders()
    }
  },
  computed: {
    path () {
      let url = new URL(ENTRYPOINT)
      return url.pathname
    },
    ableToViewTask () {
      return checkPermission('tasks', 'EXCMTaskShow')
    },
    ableToViewDocuments () {
      return checkPermission('warehouses', 'EXSBDocumentList')
    },
    contractorId () {
      if (this.item.contractorUserData) {
        return this.item.contractorUserData['@id']
      } else {
        return ''
      }
    },
    partnerId () {
      if (this.item.partnerUserData) {
        return this.item.partnerUserData['@id']
      } else {
        return ''
      }
    },
    idCase () {
      return parseInt(getId(this.item['@id']))
    },
    mobileView () {
      return this.$store.state.mobileView
    },

    ableToShowDevice () {
      return checkPermission('devices', 'EXCMDeviceShow')
    },

    ableToShowRelations () {
      return checkPermission('firms', 'EXCMRelationsList')
    },

    visibleCaseManage: function () {
      return checkPermission('cases', 'EXCMCaseShow', 'caseManage')
    },
    ableToAddOrder () {
      return checkPermission('orders', 'EXSBOrderCreate')
    },
    ableToViewOrder () {
      return checkPermission('orders', 'EXSBOrderShow') || checkPermission('dashboard', 'WholesalerOrders')
    },
    ableToViewOrderList () {
      return checkPermission('orders', 'EXSBOrderList') || checkPermission('dashboard', 'WholesalerOrders') || checkPermission('orders', 'EXSBOrderListInCase')
    },
    ...mapGetters({
      isMeetingModalVisible: 'excmrelation/createModal/getIsMeetingModalVisible',
      isPhoneModalVisible: 'excmrelation/createModal/getIsPhoneModalVisible',
      deleteError: 'excmcase/del/error',
      error: 'excmcase/show/error',
      isLoading: 'excmcase/show/isLoading',
      item: 'excmcase/show/retrieved',
      documents: 'excmcase/list/documents',
      orders: 'exsborder/list/items',
      orderCreated: 'exsborder/create/created',
      isCreateTaskModalVisible: 'excmtask/createModal/isVisible',
      createdTask: 'excmtask/create/created'
    })
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  beforeDestroy () {
    let id = getId(this.$route.params.id)
    this.$store.state.Pusher.unsubscribe('e_x_c_m_cases-' + id)
    this.reset()
  },

  created () {
    this.roleCheck()
    this.retrieve(decodeURIComponent(this.$route.params.id))
    this.getOrders()
  },
  methods: {
    async duplicateOrder (id, createNewCase = false, completed = false, priced = false) {
      const response = await new ApiService(id).getResults()
      if (!createNewCase) {
        this.duplicatedOrderId = id
        this.extractedOrderId = null
      } else {
        this.extractedOrderId = id
        this.duplicatedOrderId = null
      }
      this.initialOrderItem = {
        positions: response.positions.map(position => {
          return {
            item: position.item['@id'],
            vatRate: position.vatRate['@id'],
            quantity: position.quantity,
            measure: position.measure['@id']
          }
        }),
        orderTags: response.orderTags.map(orderTag => {
          return {
            value: orderTag.tag['@id'],
            text: orderTag.tag.tag
          }
        }),
      }
      if (completed) {
        this.initialOrderItem.completed = 1
        this.initialOrderItem.lockedPositions = JSON.parse(JSON.stringify(this.initialOrderItem.positions))
      }
      if (priced) {
        this.initialOrderItem.priced = 1
        this.initialOrderItem.lockedPositions = JSON.parse(JSON.stringify(this.initialOrderItem.positions))
      }
      this.toggleCreateOrderModal()
    },
    createOrder () {
      this.duplicatedOrderId = null
      this.extractedOrderId = null
      this.initialOrderItem = {
        positions: [],
        orderTags: [],
        completed: 0
      }
      this.toggleCreateOrderModal()
    },
    ...mapMutations({
      toggleCreateOrderModal: 'exsborder/createModal/toggleModal'
    }),
    ...mapActions({
      del: 'excmcase/del/del',
      reset: 'excmcase/show/reset',
      retrieve: 'excmcase/show/retrieve',
      task: 'excmtask/update/updated',
      fetchDocuments: 'excmcase/list/fetchDocuments',
      fetchOrders: 'exsborder/list/default',
      resetCreatedTask: 'excmtask/create/reset'
    }),
    getOrders () {
      let link = addParamsToQuery('e_x_s_b_orders', {
        idCase: getId(this.$route.params.id),
        pagination: false
      })
      this.fetchOrders(link)
    },
    deleteCaseNote (note) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        text: this.$t('notifications.deleteDescription'),
        type: 'warning',
        showCancelButton: true,
        // confirmButtonColor: '#3085d6',
        // cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(response => {
        this.del(note)
        this.$Swal({
          title: this.$t('notifications.deletedTitle'),
          type: 'success'
        })
      }, dismiss => {
        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
        if (dismiss === 'cancel') {
          this.$Swal({
            title: this.$t('notifications.deleteCancel'),
            type: 'error'
          })
        }
      })
    },
    roleCheck () {
      let roles = VueCookie.get('roles')
      if (roles && (roles.includes('ROLE_SUPER_USER') || (roles.includes('ROLE_CONTROLLING')) || (roles.includes('ROLE_OWNER')))) {
        this.ableToRevertActions = true
      }
    },
    openCase () {
      let id = this.getIdLink(this.item['@id'])
      this.$http.put('api/e_x_c_m_cases/' + id + '/cancelclose', {})
        .then(response => {
          this.$Swal({
            type: 'success',
            title: 'Operacja wykonana pomyślnie',
            timer: 2500
          })
          this.retrieve(decodeURIComponent(this.$route.params.id))
          this.getPoolTask(this.$route.params.id)
        })
        .catch(error => {
          if (error.response.status === 400 || error.response.status === 403) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    archiveItem (item) {
      this.$Swal({
        title: this.$t('notifications.archiveTitle') + ' ' + this.$t('notifications.archiveDescription'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.$http
            .put('api/e_x_c_m_cases/' + this.getIdLink(this.item['@id']), {
              state: 0
            })
            .then(response => {
              this.$router.push({ name: 'EXCMCaseList' })
              this.$Swal({ // show notification with success
                type: 'success',
                title: this.$t('notifications.update.updatedTitle'),
                showConfirmButton: false,
                timer: 2500
              })
            })
            .catch(error => {
              if (error.response.status === 400) {
                let text = ''
                for (let i in error.response.data) {
                  text += error.response.data[i] + '\n'
                }
                this.$Swal({
                  type: 'warning',
                  title: text,
                  timer: 2500
                })
              }
              console.log(error)
            })
        }
      })
    },
    unArchiveItem (item) {
      this.$http
        .put('api/e_x_c_m_cases/' + this.getIdLink(this.item['@id']), {
          state: 1
        })
        .then(response => {
          this.$Swal({ // show notification with success
            type: 'success',
            title: this.$t('notifications.update.updatedTitle'),
            showConfirmButton: false,
            timer: 2500
          })
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    settleCase (item) {
      let params = {
        idCase: this.getIdLink(item['@id'])
      }
      this.$http
        .post('api/e_x_s_b_settlements/settle', params,
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )
        .then(response => {
          this.$Swal({
            type: 'success',
            title: this.$t('notifications.store.savedTitle'),
            timer: 2500
          })
          this.$router.push({ name: 'EXSBSettlementShow', params: { id: response.data['@id'] } })
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    poolOperationTask (iri, operation) {
      if (operation === 'transfer') {
        this.$store.state.modals.excmtask.transfer.taskIRI = iri
        this.$store.state.modals.excmtask.transfer.show = 1
      } else {
        let id = this.getIdLink(iri)
        this.$http.put('api/e_x_c_m_tasks/' + id + '/' + operation,
          {}
        )
          .then(response => {
            this.$Swal({
              type: 'success',
              title: 'Operacja wykonana pomyślnie',
              timer: 2500
            })
            this.retrieve(decodeURIComponent(this.$route.params.id))
            this.getPoolTask(this.$route.params.id)
          })
          .catch(error => {
            if (error.response.status === 400 || error.response.status === 403) {
              let text = ''
              for (let i in error.response.data) {
                text += error.response.data[i] + '\n'
              }
              this.$Swal({
                type: 'warning',
                title: text,
                timer: 2500
              })
            }
            console.log(error)
          })
      }
    },
    editCase (item) {
      this.$router.push({ name: 'EXCMCaseUpdate', params: { id: item['@id'] } })
    },
    getIdLink (link) {
      return getId(link)
    },
    progressColor (percent) {
      if (percent > 0 && percent <= 50) {
        return 'success'
      } else if (percent > 50 && percent <= 80) {
        return 'warning'
      } else if (percent > 80) {
        return 'danger'
      } else {
        return 'secondary'
      }
    },
    deleteCaseProblem (caseProblem) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        text: this.$t('notifications.deleteDescription'),
        type: 'warning',
        showCancelButton: true,
        // confirmButtonColor: '#3085d6',
        // cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(response => {
        this.del(caseProblem)
        this.$Swal({
          title: this.$t('notifications.deletedTitle'),
          type: 'success'
        })
        this.retrieve(decodeURIComponent(this.$route.params.id))
      }, dismiss => {
        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
        if (dismiss === 'cancel') {
          this.$Swal({
            title: this.$t('notifications.deleteCancel'),
            type: 'error'
          })
        }
      })
    },
    closeCase (item) {
      this.$Swal({
        title: this.$t('notifications.excmcase.titleCloseCase'),
        text: this.$t('notifications.excmcase.textCloseCase'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(async response => {
        await new ApiService(item['@id'] + `/close`).put({})
      }, dismiss => {
        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
        if (dismiss === 'cancel') {
          this.$Swal({
            title: this.$t('notifications.canceled'),
            text: this.$t('notifications.excmcase.caseNotClosed'),
            type: 'error'
          })
        }
      })
    },
    closeTask (task) {
      this.$store.state.modals.excmtask.closeManually.show = 1
      this.$store.state.modals.excmtask.closeManually.taskObject = Object.assign({}, task)
    },
    async getCaseTypeParams (id) {
      const response = await new ApiService(`e_x_c_m_case_types/${getIdFromLink(id)}`).getResults()
      this.caseParams = response.caseParams
    }
  }
}
</script>
